import { ITeamDeviceDB } from "../../interfaces/Team";
import WebCamPreviewManager from "../Managers/WebCamPreviewManager";

class Cameras {
  private Cams = new Map<string, MediaStream>();
  private Devices = new Map<string, ITeamDeviceDB>();

  constructor() {}

  get(deviceId: string) {
    return this.Devices.get(deviceId) ?? null;
  }

  getAll(): ITeamDeviceDB[] {
    return [...this.Devices.values()];
  }

  async play(deviceId: string, video?: HTMLVideoElement) {
    const camera = this.get(deviceId);
    if (!camera) throw new Error(`Cámara no encontrada: ${deviceId}`);

    try {
      const stream = await WebCamPreviewManager.getStream(deviceId);

      if (!stream) {
        throw new Error(`No se pudo obtener stream de la cámara: ${deviceId}`);
      }

      if (video) {
        video.autoplay = true;
        video.srcObject = stream;
        video.volume = 0;
      }

      this.Cams.set(deviceId, stream);
    } catch (error) {
      console.error(`Error al reproducir cámara ${deviceId}:`, error);
      throw error;
    }
  }

  set(deviceId: string, device: ITeamDeviceDB) {
    this.Devices.set(deviceId, device);
  }

  async stop(deviceId: string, video?: HTMLVideoElement) {
    const device = this.get(deviceId);
    if (!device || !video) return;

    video.currentTime = 0;
  }

  delete(deviceId: string) {
    this.Cams.delete(deviceId);
    this.Devices.delete(deviceId);
  }

  destroy() {
    this.Cams.clear();
    this.Devices.clear();
  }
}

export default Cameras;
